/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class PartyRoleDialog extends SiteEntityDialog<PartyRoleRow, any> {
        protected getFormKey() { return PartyRoleForm.formKey; }
        protected getIdProperty() { return PartyRoleRow.idProperty; }
        protected getLocalTextPrefix() { return PartyRoleRow.localTextPrefix; }
        protected getNameProperty() { return PartyRoleRow.nameProperty; }
        protected getService() { return PartyRoleService.baseUrl; }

        protected form = new PartyRoleForm(this.idPrefix);

    }
}